import axios from 'axios';
import getApiUrl from '../helpers/apiUrls'
import { authHeader } from '../helpers/authHeader';
import * as actions from '../store/login/actions'
import * as type from '../store/login/actionTypes'
import * as commonType from '../store/common/actionTypes'
import * as commonActions from '../store/common/actions'
import * as utilCommon from '../helpers/utilCommon'
import {
	TO_MANY_LOGIN_ATTEMPTS_ERROR_CODE,
	ACCOUNT_DISABLED_ERROR_CODE,
	LOGIN_FALLBACK_ERROR_CODE,
	REGISTRATION_FALLBACK_ERROR_CODE
} from "../helpers/enums";
import { getFreightQuotePath } from '../helpers/utilCommon';
import { startSubmit, stopSubmit } from 'redux-form';
import lodash from "lodash";

const showResponseErrorsOrFallback = (response, fallbackErrorCode, dictionary, lang) => {
	const errors = lodash.get(response, 'data.errors', []);

	if (Array.isArray(errors) && errors.length > 0) {
		errors.forEach((error) => {
			utilCommon.showNotification(error, dictionary, lang);
		});
		return;
	}

	utilCommon.showNotification(fallbackErrorCode, dictionary, lang);
};

// var leadsUserData= {};
// Socket for getting online flag for logged in users

setInterval(() => {

	if (!utilCommon.getSession('accessToken')) {
		if (socket) {
			socket.close();
		}
		return;
	}

	// Create a new WebSocket.
	var socket = new WebSocket((window.location.protocol == 'https:' ? 'wss://' : 'ws://') + process.env.REACT_APP_SOCKET_URL.replace('http://', '').replace('https://', '') + '/v1/login-ping', [utilCommon.getSession('accessToken')]);

	// Handle any errors that occur.
	socket.onerror = function (error) {
		console.log('WebSocket Error: ', error);
	};

	// Show a connected message when the WebSocket is opened.
	socket.onopen = function (event) {
		//console.log('WebSocket Open: ', event);
		socket.send(JSON.stringify({}))
	};

	// Handle messages sent by the server.
	socket.onmessage = function (event) {
		var message = event.data;
		//console.log('OnMessage', JSON.parse(event.data))

	};

}, 10000)

let reloginInProgress = false;
let failedRefreshToken = null;

const endSession = () => {
  utilCommon.clearSession();
  const quoteSearchString = sessionStorage.getItem('quoteSearchString');
  window.location.replace(quoteSearchString ? getFreightQuotePath(quoteSearchString) : '/home/login');
};

const refreshSession = () => {
  if (reloginInProgress) return;

  const refreshToken = utilCommon.getSession('refreshToken');
  if (!refreshToken) {
    endSession();
    return;
  }
  if (failedRefreshToken === refreshToken) return;

  reloginInProgress = true;
  axios.post(getApiUrl('login', 'login'), {}, { headers: { ...authHeader(), refreshToken } })
    .then((response) => {
      if (!lodash.get(response, 'data.success')) {
        endSession();
        return;
      }

      utilCommon.setSession('accessToken', response.data.content.responseData.accessToken);
      window.location.reload();
    })
    .catch(() => { failedRefreshToken = refreshToken; })
    .finally(() => { reloginInProgress = false; });
};

// Permissions interceptor
axios.interceptors.response.use(function (response) {
  if (reloginInProgress && lodash.get(response, 'config.url') === getApiUrl('login', 'login')) return response;

  const requestAccessToken = lodash.get(response, 'config.headers.accessToken');
  if (response && response.data && response.data.message && response.data.message == 1028) {
    if (requestAccessToken && requestAccessToken === utilCommon.getSession('accessToken')) refreshSession();
  } else if (response && response.data && (response.data.message && response.data.message == 401) || (response.data.errors && response.data.errors.includes && response.data.errors.includes(401))) {
    if (response.data.message == 401 && requestAccessToken && requestAccessToken === utilCommon.getSession('accessToken')) {
      endSession();
    } else if (!requestAccessToken && !utilCommon.getSession('accessToken') && utilCommon.getSession('refreshToken')) {
      refreshSession();
    }
  } else if (response && response.data && response.data.message && response.data.message == 1030) {
    utilCommon.removeSession('refreshToken')
    utilCommon.removeSession('accessToken')
    utilCommon.clearSession()
    if (sessionStorage.getItem('quoteSearchString')) {
	  window.location.replace(getFreightQuotePath((sessionStorage.getItem('quoteSearchString') || '')));
    } else if (window.location.pathname !== '/home') {
      window.location.replace('/home')
    }
  }
  return response;
}, function (error) {
  return Promise.reject(error);
});

//login
export const login = (dispatch, lang, dictionary, inputDTO, guestSignUp, refreshFlag, forceRedirect = false) => {
	dispatch(startSubmit('LoginForm'));
	const params = { headers: authHeader() };
	const url = getApiUrl('login', 'login');

	dispatch(commonActions.setLoader(true))
	return axios.post(url, inputDTO, params)
		.then((response) => {
			let redirectUrl = sessionStorage.getItem('loginRedirect');

			dispatch(commonActions.setLoader(false))

			if (lodash.get(response, 'data.success', false)) {
				if (!guestSignUp && Number(lodash.get(response, 'data.content.responseData.tmpPasswordStatus')) === 1) {
					sessionStorage.setItem('resetPasswordEmail', response.data.content.responseData.emailId);
					sessionStorage.setItem('tmpPasswordStatus', 1);
					window.location.href = '/resetpassword/updateTempPassword';
					return;
				}
				utilCommon.setSession('fname', response.data.content.responseData.firstName)
				utilCommon.setSession('lname', response.data.content.responseData.lastName)
				utilCommon.setSession('userId', response.data.content.responseData.userId)
				utilCommon.setSession('userUuid', response.data.content.responseData.userUuid)
				utilCommon.setSession('username', response.data.content.responseData.firstName)
				utilCommon.setSession('userEmail', response.data.content.responseData.emailId)
				utilCommon.setSession('cellPhone', response.data.content.responseData.cellPhone)
				utilCommon.setSession('company', response.data.content.responseData.customerCompany)
				utilCommon.setSession('accessToken', response.data.content.responseData.accessToken)
				utilCommon.setGaUserId(response.data.content.responseData.userId);

				if(!refreshFlag){
					utilCommon.setSession('refreshToken', response.data.content.responseData.refreshToken)
				}

				dispatch(actions.setCredentials(response.data.content.responseData.accessToken,
					response.data.content.responseData.refreshToken, response.data.content.responseData.email_id))

				if (!guestSignUp) {
					if (response.data.content.responseData.customerCompany && !lodash.isUndefined(Window['history'])) {
						Window['history'].push('/customer');
					}

          			if (refreshFlag){
            			window.location.reload()
          			}
        		} else {
					utilCommon.setSession('guestSignUp', true)
					dispatch({ type: type.ALLOW_GET_QUOTE, allowGuest: true })
				}

				if (redirectUrl) {
					sessionStorage.removeItem('loginRedirect');

					if (shouldRedirect(redirectUrl)) {
						window.location.href = redirectUrl;
					}
				}

				dispatch(stopSubmit('LoginForm'));
			} else {
				const errors = lodash.get(response, 'data.errors', []);

				if (!Array.isArray(errors) || errors.length === 0) {
					showResponseErrorsOrFallback(response, LOGIN_FALLBACK_ERROR_CODE, dictionary, lang);
				} else if (errors.some((error) => Number(error) === ACCOUNT_DISABLED_ERROR_CODE)) {
					dispatch(actions.setAccountDisabled(true));
					utilCommon.clearSession();

					if (window.location.pathname !== '/home/login') {
						Window['history'].push('/home/login');
					}

					dispatch(stopSubmit('LoginForm'));
					return response;
				} else {
					errors.forEach((error) => {
						if (Number(error) !== TO_MANY_LOGIN_ATTEMPTS_ERROR_CODE) {
							utilCommon.showNotification(error, dictionary, lang)
						} else {
							dispatch(actions.setToManyLoginAttempts(true))
						}
					})
				}
				utilCommon.clearSession()
			}

			dispatch(stopSubmit('LoginForm'));
			return response;
		})
		.catch((err) => {
			utilCommon.clearSession()
			dispatch(commonActions.setLoader(false))
			dispatch(stopSubmit('LoginForm'));
			showResponseErrorsOrFallback(
				lodash.get(err, 'response'),
				LOGIN_FALLBACK_ERROR_CODE,
				dictionary,
				lang
			);
		});
};
//sent a email on forgot password
export const forgotPassword = (dispatch, lang, dictionary, inputDTO) => {
	const params = { headers: authHeader() };
	const url = getApiUrl('login', 'forgotPassword');
	const ACCOUNT_DOES_NOT_EXIST = '4642';
	const PASSWORD_RESET_COOLDOWN = '4645';
	dispatch(commonActions.setLoader(true))
	axios.post(url, inputDTO, params)
		.then((response) => {
			dispatch(commonActions.setLoader(false))
			if (response.data.success) {
				dispatch({ type: type.EMAIL_SENT, flag: true })
				dispatch({ type: type.RESET_FLAG })
			} else {
				if (
					response.data.success ||
					(response.data.errors && response.data.errors.includes(ACCOUNT_DOES_NOT_EXIST))
				) {
					dispatch({ type: type.EMAIL_SENT, flag: true });
					dispatch({ type: type.RESET_FLAG });
					return;
				}

				if (
					response.data.errors &&
					response.data.errors.includes(PASSWORD_RESET_COOLDOWN) &&
					response.data.content &&
					response.data.content.retryAfterSeconds
				) {
					const retryAfterMinutes = Math.max(
						1,
						Math.ceil(response.data.content.retryAfterSeconds / 60)
					);
					utilCommon.showNotification(
						`A password reset email has already been sent. Please try again in ${retryAfterMinutes} minutes.`,
						dictionary,
						lang,
						false,
						'error'
					);
					return;
				}

				response.data.errors.map((error) => {
					utilCommon.showNotification(error, dictionary, lang)
				})
			}
		})
		.catch((err) => {
			dispatch(commonActions.setLoader(false))
		});
};
//reset password
export const resetPassword = (dispatch, lang, dictionary, inputDTO) => {
	const params = { headers: {} };
	const url = getApiUrl('login', 'resetPassword')
	dispatch(commonActions.setLoader(true))

	axios.post(url, inputDTO, params)
		.then((response) => {
			dispatch(commonActions.setLoader(false))
			sessionStorage.removeItem('resetPasswordEmail');
			sessionStorage.removeItem('tmpPasswordStatus');

			if (response.data.success) {
				utilCommon.showNotification(response.data.message, dictionary, lang)
				login(dispatch, lang, dictionary, {
					emailId: inputDTO.customerEmailId,
					password: inputDTO.password
				}, false).then((loginResponse) => {
					if (lodash.get(loginResponse, 'data.success', false)) {
						Window['history'].push('/customer');
					}
				})
			} else {
				response.data.errors.map((error) => {
					utilCommon.showNotification(error, dictionary, lang)
				})
			}
		})
		.catch((err) => {
			dispatch(commonActions.setLoader(false))
		});
};
//change password
export const changePassword = (dispatch, lang, dictionary, inputDTO) => {
	const params = { headers: authHeader() };
	const url = getApiUrl('login', 'changePassword');
	dispatch(commonActions.setLoader(true))
	axios.put(url, inputDTO, params)
		.then((response) => {
			dispatch(commonActions.setLoader(false))
			if (response.data.success) {
				dispatch({ type: type.PASSWORD_UPDATED, passwordUpdated: true })
				utilCommon.showNotification(response.data.message, dictionary, lang)
			} else {
				response.data.errors.map((error) => {
					utilCommon.showNotification(error, dictionary, lang)
				})
			}
		})
		.catch((err) => {
			dispatch(commonActions.setLoader(false))
		});
};

export const updateShippingFrequency = (dispatch, lang, dictionary, inputDTO, guestSignUp) => {
    const params = {headers: authHeader()};
    const url = getApiUrl('login', 'updateShippingFrequency');

    dispatch(commonActions.setLoader(true));

    return axios.put(url, inputDTO, params)
        .then((response) => {
            dispatch(commonActions.setLoader(false));

            if (response.data.success) {
                login(dispatch, lang, dictionary, {
                    emailId: inputDTO.customerEmailId,
                    password: inputDTO.password
                }, guestSignUp);
            } else {
                response.data.errors.map((error) => {
                    utilCommon.showNotification(error, dictionary, lang);
                });
            }

            return response;
        })
        .catch((err) => {
            dispatch(commonActions.setLoader(false));
        });
}

// guest sign up
export const guestSignUp = (dispatch, lang, dictionary, inputDTO, guestSignUp) => {
	const params = { headers: authHeader() };
	const url = getApiUrl('login', 'guestSignUp');
	if (!lodash.isEmpty(sessionStorage.getItem('utmCampaign'))) inputDTO.utmCampaign = sessionStorage.getItem('utmCampaign');
	if (!lodash.isEmpty(sessionStorage.getItem('utmSource'))) inputDTO.utmSource = sessionStorage.getItem('utmSource');
	dispatch(commonActions.setLoader(true))
	return axios.post(url, inputDTO, params)
		.then((response) => {
			dispatch({type: commonType.CHANGE_SIGN_UP_METHOD, method: ''});
			dispatch(commonActions.setLoader(false))
			if (lodash.get(response, 'data.success', false)) {
				utilCommon.setSession('customerId', response.data.content.customerId);
				utilCommon.setGaUserId(response.data.content.customerId);
				window.gtag('event', 'sign_up', {send_to: 'G-VH120JR471'});
				if (!inputDTO.isCommercial) {
					login(dispatch, lang, dictionary, {
						emailId: inputDTO.customerEmailId,
						password: inputDTO.password
					}, guestSignUp)
				}
			} else {
				showResponseErrorsOrFallback(response, REGISTRATION_FALLBACK_ERROR_CODE, dictionary, lang);
			}
			return response;
		})
		.catch((err) => {
			dispatch({type: commonType.CHANGE_SIGN_UP_METHOD, method: ''});
			dispatch(commonActions.setLoader(false))
			showResponseErrorsOrFallback(
				lodash.get(err, 'response'),
				REGISTRATION_FALLBACK_ERROR_CODE,
				dictionary,
				lang
			);
		});
};

export const linkSocialAccount = (dispatch, lang, dictionary, inputDTO, guestSignUp) => {
	const url = getApiUrl('login', 'linkSocialAccount');
	dispatch(commonActions.setLoader(true));
	const params = { headers: authHeader() };
	if (!inputDTO.email) {
		inputDTO.email = inputDTO.linkEmail;
	}
	axios.post(url, inputDTO, params)
		.then((response) => {
			dispatch(commonActions.setLoader(false));
			if (response.data.success) {
				login(dispatch, lang, dictionary, {
					emailId: inputDTO.email,
					password: inputDTO.password
				}, guestSignUp)
			} else {
				console.log('err',response.data);
				response.data.errors.map((error) => {
					utilCommon.showNotification(error, dictionary, lang)
				})
			}
		})
		.catch((err) => {
			dispatch({type: commonType.CHANGE_SIGN_UP_METHOD, method: ''});
			dispatch(commonActions.setLoader(false))
		});
}

export const facebookSignIn = (dispatch, lang, dictionary, facebookResponse, guestSignUp = false) => {
	const url = getApiUrl('login', 'guestSignUpFacebook');
	dispatch(commonActions.setLoader(true));
	const params = { headers: authHeader() };
	axios.post(url, facebookResponse, params)
		.then((response) => {
			let redirectUrl = sessionStorage.getItem('loginRedirect');
			sessionStorage.removeItem('loginRedirect');
			dispatch(commonActions.setLoader(false));
			dispatch({type: commonType.CHANGE_SIGN_UP_METHOD, method: ''});
			if (response.data.success) {
				utilCommon.setSession('accessToken', response.data.content.accessToken);
				utilCommon.setSession('fname', response.data.content.firstName);
				utilCommon.setSession('lname', response.data.content.lastName);
				utilCommon.setSession('userId', response.data.content.userId);
				utilCommon.setSession('userUuid', response.data.content.userUuid);
				utilCommon.setSession('username', response.data.content.firstName);
				utilCommon.setSession('userEmail', response.data.content.emailId || '');

				if (guestSignUp) {
					utilCommon.setSession('guestSignUp', true);
				}

				dispatch(commonActions.setRequiredCustomerData(response.data.content.social_required_data))
				dispatch({type: commonType.CHANGE_SOCIAL_REQUIRED_DATA, flag: response.data.content.social_required_data});
				dispatch({type: commonType.CHANGE_IS_COMMERCIAL, flag: response.data.content.customerType == 2});

				dispatch({ type: type.ALLOW_GET_QUOTE, allowGuest: true });

				dispatch(
					actions.setCredentials(
						response.data.content.accessToken,
						response.data.content.refreshToken,
						response.data.content.emailId
					)
				);

				if (redirectUrl) {
					window.location.href = redirectUrl;
				}
			} else {
				response.data.errors.map((error) => {
					if (error == 3253) {
						dispatch({
							type: commonType.SET_LINK_DATA,
							linkEmail: facebookResponse.email,
							linkSocialKey: facebookResponse.id,
							linkSocialType: 'facebook'
						});
					} else {
						utilCommon.showNotification(error, dictionary, lang)
					}
				});
				utilCommon.clearSession();
			}
		})
		.catch((err) => {
			dispatch({type: commonType.CHANGE_SIGN_UP_METHOD, method: ''});
			dispatch({type: commonType.CHANGE_SIGN_UP_METHOD, method: ''});
			utilCommon.clearSession();
			dispatch(commonActions.setLoader(false));
		});
}

// logs out a new customer
export const logout = (dispatch, lang, dictionary, history) => {
	// utilCommon.clearSession()
	// 	dispatch({ type : 'login/SET_CREDENTIALS' , token : null , email : null, refreshToken : null })
	// 	history.push('/home/login')
	// 	window.location.reload()
  sessionStorage.removeItem('quoteQuery');
  sessionStorage.removeItem('quotePayload');
	const params = { headers: authHeader() };
	const url = getApiUrl('login', 'logout');
	dispatch(commonActions.setLoader(true))
	axios.post(url,{}, params)
		.then((response) => {
			dispatch(commonActions.setLoader(false))
			utilCommon.clearSession()
				dispatch({ type : 'login/SET_CREDENTIALS' , token : null , email : null, refreshToken : null })
			history.push('/home/login')
			window.location.reload()
			/*if (response.data.success) {
				utilCommon.clearSession()
				dispatch({ type : 'login/SET_CREDENTIALS' , token : null , email : null, refreshToken : null })
				history.push('/home/login')
				window.location.reload()
			} else {
				// response.data.errors.map((error) => {
					utilCommon.showNotification('Unable to logout', dictionary, lang)
				// })
			}*/
		})
		.catch((err) => {
			dispatch(commonActions.setLoader(false))
		});
};


export const resetToken = (dispatch, lang, dictionary, inputDTO,history) => {
	const params = { headers: authHeader() };
	let url = getApiUrl('login', 'resetToken');
	url = url + '?activationCode='+inputDTO.activationCode
	dispatch(commonActions.setLoader(true))
	axios.get(url, params)
		.then((response) => {
			dispatch(commonActions.setLoader(false))
			if (!response.data.success) {
				history.push('/home/login',{redirectionFP:true})
				response.data.errors.map((error) => {
					utilCommon.showNotification(error, dictionary, lang)
				})
			}
		})
		.catch((err) => {
			dispatch(commonActions.setLoader(false))
		});
};

export const hashInfo = (dispatch, lang, dictionary, hash) => {
	const params = {headers: {}};
	const data = {hash: hash};
	const url = getApiUrl('login', 'hashInfo');

	sessionStorage.removeItem('resetPasswordEmail')

	axios.post(url, data, params)
		.then((response) => {
			if (response.data.email) {
				sessionStorage.setItem('resetPasswordEmail', response.data.email);
				dispatch(actions.setResetPasswordEmail(response.data.email))
			} else {
				utilCommon.showNotification('Activation code not found.', dictionary, lang, true)
			}
		});
};


// export const healthCheck = (dispatch, lang, dictionary, inputDTO) => {
// 	const params = { headers: authHeader() };
// 	let url = getApiUrl('login', 'healthCheck');
// 	dispatch(commonActions.setLoader(true))
// 	axios.get(url, params)
// 		.then((response) => {
// 			dispatch(commonActions.setLoader(false))
// 			if (response.data.success) {
// 				dispatch({ type: type.SET_HEALTH_CHECK, messageStatus: response.data.content })
// 			} else {
// 				response.data.errors.map((error) => {
// 					utilCommon.showNotification(error, dictionary, lang)
// 				})
// 			}
// 		})
// 		.catch((err) => {
// 			dispatch(commonActions.setLoader(false))
// 	});
// };


export const healthCheck = (dispatch, lang, dictionary, inputDTO) => {
	const params = { headers: authHeader() };
	dispatch(commonActions.setLoader(true))
	dispatch({ type: type.SET_HEALTH_CHECK, messageStatus: 200 })
};

export const shouldRedirect = (url) => {
	return !url.startsWith('/customer/ftl');
}


export default {
	login,
	linkSocialAccount,
	resetPassword,
	forgotPassword,
	changePassword,
	guestSignUp,
	facebookSignIn,
	logout,
	resetToken,
	healthCheck,
	updateShippingFrequency,
	hashInfo
};
